import React from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { useCart } from "../context/CartContext";
import { resolveImg } from "../api";

const CartDrawer = () => {
  const { items, remove, setQty, subtotal, open, setOpen, count } = useCart();

  return (
    <>
      <div
        onClick={() => setOpen(false)}
        className={`fixed inset-0 bg-black/30 z-40 transition-opacity duration-500 ${
          open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
      />
      <aside
        className={`fixed top-0 right-0 h-full w-full sm:w-[440px] bg-white z-50 border-l border-[color:var(--line)] transition-transform duration-500 flex flex-col ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="px-6 py-5 flex items-center justify-between border-b border-[color:var(--line)]">
          <div className="flex items-baseline gap-3">
            <span className="upper font-serif">Cart</span>
            <span className="upper-sm font-serif text-[color:var(--ink-mute)] counter">({count})</span>
          </div>
          <button onClick={() => setOpen(false)} className="upper font-serif tlink" aria-label="Close">Close</button>
        </div>

        <div className="flex-1 overflow-auto">
          {items.length === 0 ? (
            <div className="h-full flex flex-col items-center justify-center px-6 text-center gap-4">
              <p className="font-serif text-3xl">Empty for now.</p>
              <p className="upper-sm font-serif text-[color:var(--ink-mute)]">Books — prints — short films</p>
              <Link to="/shop" onClick={() => setOpen(false)} className="upper font-serif tlink mt-2">Browse the shop →</Link>
            </div>
          ) : (
            <ul className="divide-y divide-[color:var(--line)]">
              {items.map((i) => (
                <li key={i.id} className="px-6 py-5 flex gap-4">
                  <div className="w-20 h-24 bg-[color:var(--paper-2)] overflow-hidden flex-none">
                    {i.cover ? (
                      <img src={resolveImg(i.cover)} alt={i.title} className="w-full h-full object-cover" />
                    ) : null}
                  </div>
                  <div className="flex-1 flex flex-col justify-between">
                    <div>
                      <p className="upper font-serif">{i.title}</p>
                      <p className="upper-sm font-serif text-[color:var(--ink-mute)] mt-1">{i.type === "film" ? "Digital rental" : "Print item"}</p>
                    </div>
                    <div className="flex items-center justify-between mt-2">
                      <div className="inline-flex items-center border border-[color:var(--line)]">
                        <button onClick={() => setQty(i.id, i.qty - 1)} className="px-2 py-1 font-serif">−</button>
                        <span className="px-3 upper-sm font-serif counter">{i.qty}</span>
                        <button onClick={() => setQty(i.id, i.qty + 1)} className="px-2 py-1 font-serif">+</button>
                      </div>
                      <div className="flex items-center gap-3">
                        <span className="font-serif counter text-lg">€{(i.price * i.qty).toFixed(2)}</span>
                        <button onClick={() => remove(i.id)} className="text-[color:var(--ink-mute)] hover:text-[color:var(--ink)]"><X className="w-3.5 h-3.5" /></button>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>

        {items.length > 0 && (
          <div className="border-t border-[color:var(--line)] px-6 py-5 space-y-4">
            <div className="flex items-baseline justify-between">
              <span className="upper font-serif text-[color:var(--ink-mute)]">Subtotal</span>
              <span className="font-serif text-2xl counter">€{subtotal.toFixed(2)}</span>
            </div>
            <p className="upper-sm font-serif text-[color:var(--ink-mute)]">Shipping calculated at checkout</p>
            <button onClick={() => { setOpen(false); alert("This is a demo checkout — payment integration (Stripe) can be added on request."); }} className="btn-sober w-full justify-center">Checkout</button>
            <Link to="/cart" onClick={() => setOpen(false)} className="block text-center upper-sm font-serif tlink tlink-mute">View full cart</Link>
          </div>
        )}
      </aside>
    </>
  );
};

export default CartDrawer;
